import { JoinedClubCard } from "~/components/Components/JoinedClubCard/JoinedClubCard";
import { SelectNetworkDropdown } from "~/components/Components/SelectNetworkDropdown/SelectNetworkDropdown";

type Props = {
  joinedClubCardListProps: React.ComponentProps<typeof JoinedClubCard>[];
};

export const MyPageClubListModule = (props: Props) => {
  return (
    <div className="flex w-full flex-col items-center py-[20px]">
      {/* <div className="flex w-full flex-row items-center justify-end">
        <SelectNetworkDropdown />
      </div> */}
      {props.joinedClubCardListProps.length > 0 ? (
        <div className="flex w-full flex-col gap-[14px] px-[20px]">
          {props.joinedClubCardListProps.map((joinedClub, index) => (
            <JoinedClubCard key={index} {...joinedClub} />
          ))}
        </div>
      ) : (
        <p className="text-[17px] font-bold">No Data</p>
      )}
    </div>
  );
};
